import { api } from 'redux/api/index.api';
import { getUserInfosServiceVersion } from 'utils/constants';

export const authorizationApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchSpecialRights: builder.query({
      query: () => ({
        url: `${getUserInfosServiceVersion()}/authorization/special-rights`,
        method: 'GET',
      }),
      transformResponse: response => {
        if (!Array.isArray(response)) {
          return [];
        }
        return response.map(action => ({
          level: action === 'read-admin-portal' ? 0 : null,
          scope_type: 'Root',
          action,
        }));
      },
    }),
  }),
  overrideExisting: 'throw',
});

export const { useFetchSpecialRightsQuery, useLazyFetchSpecialRightsQuery } = authorizationApi;
